import React, { useCallback, useState } from 'react';
import { Box } from '@mui/material';
import { Tooltip } from '../Tooltip';
import { useDOM } from '../hooks/useDOM';
/**
 * Render single-line text, and omit the text and show a tooltip only if the text is
 * too long to show in a single line.
 */
export default ({ component = 'div', title, tooltipProps, children, ...otherProps }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const recalculateWidth = useCallback(() => {
        // eslint-disable-next-line no-use-before-define
        const box = boxRef.current;
        // istanbul ignore next
        if (!box) {
            return;
        }
        setShowTooltip(box.clientWidth < box.scrollWidth);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [boxMounted, boxRef] = useDOM((ref) => {
        if (window.ResizeObserver) {
            const resizeObserver = new window.ResizeObserver(recalculateWidth);
            resizeObserver.observe(ref);
            recalculateWidth();
            return () => {
                resizeObserver.disconnect();
            };
        }
        return undefined;
    }, [recalculateWidth]);
    const shownTitle = title ?? (typeof children === 'string' ? children : undefined);
    return (React.createElement(Tooltip, { title: showTooltip ? shownTitle : undefined, disableInteractive: true, "aria-describedby": undefined, "aria-description": "", ...tooltipProps }, React.createElement(component, otherProps, React.createElement(Box, { sx: {
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            display: 'inline-block',
            verticalAlign: 'top',
            maxWidth: '100%',
        }, ref: boxMounted }, children))));
};
